import {Injectable, signal} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ShortcutHelpState {
	readonly visible = signal(false);
}
